import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import {
  MaintenanceStatus,
  MaintenanceStatusService,
} from '@shared/services/maintenance-status.service';

@Component({
  selector: 'app-maintenance-banner',
  templateUrl: './maintenance-banner.component.html',
  styleUrls: ['./maintenance-banner.component.scss'],
})
export class MaintenanceBannerComponent implements OnInit, OnDestroy {
  status: MaintenanceStatus | null = null;
  private sub: Subscription | undefined;

  constructor(private maintenanceStatusService: MaintenanceStatusService) {}

  ngOnInit(): void {
    this.sub = this.maintenanceStatusService.maintenanceStatus$.subscribe(
      (status) => (this.status = status?.scheduled ? status : null)
    );
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
